import "core-js/modules/es.array.push.js";
import axios from "axios";
import { inject } from "vue";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      order: "",
      count: 0,
      isVisible: false,
      products: [],
      dialogVisible: false,
      newMarker: [],
      formattedDate: [],
      error: false
    };
  },
  methods: {
    ...mapActions({
      geocoderAddress: "map/geocoderAddress",
      dateFormat: "date/dateFormat"
    }),
    async fetchOrder() {
      let apiRes = null;
      try {
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/orders?number=${this.historyOrder}`);
        this.order = data[0];
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.error = true;
          this.$router.push('/rol-shop/404');
        }
      }
    },
    geocoderCoord(lat, long) {},
    creatingMarker() {
      const fullAddres = `${this.order.address.city}, ${this.order.address.address}`;
      this.geocoderAddress(fullAddres).then(() => {
        this.newMarker = this.arrayCoord;
      });
    }
  },
  computed: {
    ...mapState({
      arrayCoord: state => state.map.arrayCoord
    })
  },
  mounted() {
    this.fetchOrder().then(() => {
      if (!this.error) {
        this.dateFormat({
          dayDate: this.order.day,
          yearDate: this.order.year,
          timeDate: this.order.time
        }).then(result => {
          this.formattedDate = result;
        });
        this.order.items.forEach(element => {
          this.count += element.count;
        });
        this.products = this.order.items;
        if (this.order.freeProduct) {
          this.order.freeProduct.forEach(item => this.products.push(item));
          this.count += this.order.freeProduct.length;
        }
        this.creatingMarker();
      }
    });
  },
  setup() {
    const {
      historyOrder
    } = inject("cart");
    return {
      historyOrder
    };
  }
};